import { useSelector } from 'react-redux';
import {
    getTasksPaneMode,
    getTasksAsSourceSet,
    getTasksSourceSetModel,
    getSelectedTaskId,
    getSelectedTasks,
    isTasksPaneVisible,
    getTasksStatus,
    getTasksSourceSetWithFilter,
    getPreviewTask,
    getLinkageAction,
    getLocationPosition,
    getAddMarkerMode,
} from './';

export const useIsTasksPaneVisible = () => useSelector(isTasksPaneVisible);
export const useTasks = () => useSelector(getTasksAsSourceSet);
export const useTasksSourceSetWithFilter = () =>
    useSelector(getTasksSourceSetWithFilter);
export const useTasksMode = () => useSelector(getTasksPaneMode);
export const useTasksSourceSetModel = () => useSelector(getTasksSourceSetModel);
export const useTasksStatus = () => useSelector(getTasksStatus);
export const useSelectedTaskId = () => useSelector(getSelectedTaskId);

export const useSelectedTasks = () => useSelector(getSelectedTasks);
export const useLinkageAction = () => useSelector(getLinkageAction);

export const usePreviewTask = () => useSelector(getPreviewTask);
export const useLocationPosition = () => useSelector(getLocationPosition);
export const useIsAddMarkerMode = () => useSelector(getAddMarkerMode);
